module.exports = __webpack_public_path__ + "img/nekoReborn.50f21d19.jpg";